
export const paymentRadioBtn = [
  {
    value: 'Cheque',
    label: 'Cheque',
  },
  {
    value: 'DemandDraft',
    label: 'Demand draft',
  },
  {
    value: 'RTGS',
    label: 'NEFT/RTGS',
  },
]

export function ChequeDetails() {

  let obj = '';
  return (obj = {
    '': [
      {
        textField: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Enter payee name',
        type: 'text',
        name: 'payee',
        label: 'Payee Name',
        fieldDisabled: true,
      },
      {
        datePicker: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Date',
        type: 'Date',
        name: 'chooseDate',
        label: 'Date',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter Cheque No',
        type: 'number',
        name: 'chequeNo',
        label: 'Cheque No',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter bank name',
        type: 'text',
        name: 'bankName',
        label: 'Bank Name',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        rupee:true,
        placeholder: 'Enter amount in number',
        type: 'number',
        name: 'amount',
        label: 'Amount',
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 3.8,
        name: 'image',
        placeholder: 'Upload File',
        label: 'Upload File',
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    "Additional Details":[
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter TDS',
        type: 'number',
        name: 'tds',
        label: 'TDS',
        rupee:true,
      },
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter Remark',
        type: 'text',
        name: 'remark',
        label: 'Remark',
      }
    ]
    
  });
}

export function DemandDraftDetails() {

  let obj = '';
  return (obj = {
    '': [
      {
        textField: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Enter payee name',
        type: 'text',
        name: 'payee',
        label: 'Payee Name',
        fieldDisabled: true,
      },
      {
        datePicker: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Date',
        type: 'Date',
        name: 'chooseDate',
        label: 'Date',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter demand draft No',
        type: 'number',
        name: 'demandNo',
        label: 'DD No',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter bank name',
        type: 'text',
        name: 'bankName',
        label: 'Bank Name',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        rupee:true,
        placeholder: 'Enter amount in number',
        type: 'number',
        name: 'amount',
        label: 'Amount',
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 3.8,
        name: 'image',
        placeholder: 'Upload File',
        label: 'Upload File',
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],

    "Additional Details":[
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter TDS',
        type: 'number',
        name: 'tds',
        label: 'TDS',
        rupee:true,
      },
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter Remark',
        type: 'text',
        name: 'remark',
        label: 'Remark',
      }
    ]
    
  });
}

export function UtrDetails() {

  let obj = '';
  return (obj = {
    '': [
      {
        textField: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Enter payee name',
        type: 'text',
        name: 'payee',
        label: 'Payee Name',
      },
      {
        datePicker: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Date',
        type: 'Date',
        name: 'chooseDate',
        label: 'Date',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter transaction id',
        type: 'text',
        name: 'transactionId',
        label: 'Transaction ID',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter bank name',
        type: 'text',
        name: 'bankName',
        label: 'Bank Name',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter virtual payment address',
        type: 'text',
        name: 'vpa',
        label: 'VPA (Virtual Payment Address)',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter Email ID',
        type: 'email',
        name: 'emailID',
        label: 'Email ID',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter mobile No',
        type: 'phone',
        name: 'mobileNo',
        label: 'Register Mobile No',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        rupee:true,
        placeholder: 'Enter amount in number',
        type: 'number',
        name: 'amountNumber',
        label: 'Amount',
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 3.8,
        name: 'image',
        placeholder: 'Upload File',
        label: 'Upload File',
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    
  });
}


export function rtgsDetails() {

  let obj = '';
  return (obj = {
    '': [
      {
        textField: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Enter payee name',
        type: 'text',
        name: 'payee',
        label: 'Payee Name',
        fieldDisabled: true,
      },
      {
        datePicker: true,
        required: true,
        gridSize: 3.8,
        placeholder: 'Date',
        type: 'Date',
        name: 'chooseDate',
        label: 'Date',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter bank name',
        type: 'text',
        name: 'bankName',
        label: 'Bank Name',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter branch name',
        type: 'text',
        name: 'branchName',
        label: 'Branch Name',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter account no',
        type: 'number',
        name: 'accountNo',
        label: 'Account No',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter Transaction No. / UTR No',
        type: 'text',
        name: 'utrTransactionId',
        label: 'Transaction No. / UTR No',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        placeholder: 'Enter time of reciept',
        type: 'time',
        name: 'receiptTime',
        label: 'Time of Receipt',
      },
      {
        textField: true,
        gridSize: 3.8,
        required: true,
        rupee:true,
        placeholder: 'Enter amount in number',
        type: 'number',
        name: 'amount',
        label: 'Amount',
      },
      {
        fileUpload: true,
        required: true,
        gridSize: 3.8,
        name: 'chequeFile',
        placeholder: 'Upload File',
        label: 'Upload File',
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],

    "Additional Details":[
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter TDS',
        type: 'number',
        name: 'tds',
        label: 'TDS',
        rupee:true,
      },
      {
        textField: true,
        gridSize: 3.8,
        required: false,
        placeholder: 'Enter Remark',
        type: 'text',
        name: 'remark',
        label: 'Remark',
      }
    ]
    
  });
}

export const paymentFilterOptions = ( subCompanyList, cityList) =>  [
  {
    id: 1,
    name: "companyName",
    label: "Company Name",
    placeholder: "Choose Company Name",
    options: subCompanyList
  },
  {
    id: 2,
    name: "city",
    label: "City",
    placeholder: "Choose City",
    options: cityList
  }
  ];


